import { render, staticRenderFns } from "./ImportRoleSettings.vue?vue&type=template&id=4ec03ae5&scoped=true&"
import script from "./ImportRoleSettings.vue?vue&type=script&lang=ts&"
export * from "./ImportRoleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec03ae5",
  null
  
)

export default component.exports